module.exports = __webpack_public_path__ + "static/media/Reportsactive.fa7852c9.png";